export default __webpack_public_path__ + "static/media/emp1.81141415.png";